module.exports = __webpack_public_path__ + "img/1949_uk.f74179df.svg";